import React, { useEffect, useState } from "react";
import Sidebar from "../Components/Sidebar";
import Header from "../Components/Header";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { Col, Container, Modal, Row } from "react-bootstrap";
import OrderStatus from "../Components/OrderStatus";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import useAxiosFile from "../actions/useaxios";
import { DateTimeForm, DecryptData, EncryptData, NumberChange, isEmpty, returnArrayString } from "../actions/common";
import moment from "moment";
import { toast } from "react-toastify";
import QrReader from 'react-qr-reader';
import { IoMdCloseCircle } from "react-icons/io";
import { Link } from "react-router-dom";
import Select from "react-select";


function OrdersView() {
  const { toggle, payload, token } = useSelector(
    (state) => state.seller_panel.User
  );
  const location = useLocation();

  const axiosfile = useAxiosFile();

  const [Id, Setid] = useState("");
  const [Detail, SetDetail] = useState({});
  const [Disabled, SetDisabled] = useState(false);

  const [confirmmodel, setconfirmmodel] = useState(false);
  const [alertmodel, setalertmodel] = useState(false);
  const [submit, setsubmit] = useState(false);
  const [showModal, SetShowModal] = useState(false)
  const [PackNumber, setPackNumber] = useState([]);
  const [number, setnumber] = useState('');
  const [position, setposition] = useState(false);
  const [orderdata, setOrderData] = useState([]);
  const [Options, Setoptions] = useState([]);
  const [status, Setselectstatus] = useState({});


  function createData(no, orderid, name, type, date) {
    return { no, orderid, name, type, date };
  }

  const latestorders = [
    createData(1, "Coco Strawberry Pancake", "$9.49", "1", "$9.49"),
    createData(2, "Coco Strawberry Pancake", "$2.50", "2", "$5.00"),
    createData(3, "Coco Strawberry Pancake", "$2.50", "2", "$5.00"),
  ];

  useEffect(() => {
    if (location?.search) {
      let paramdata = location.search.split("?id=")[1];
      Setid(
        isEmpty(DecryptData(paramdata)) ? paramdata : DecryptData(paramdata)
      );
    }
  }, [location.search]);

  useEffect(() => {
    if (Id) {
      GetOrderDetail();
    }
  }, [Id, payload]);

  useEffect(() => {
    let Optionsdata = []
    if (isEmpty(Detail?.Time?.ApprovedBySeller) && isEmpty(Detail?.Time?.cancelbyseller) && isEmpty(Detail?.Time?.returned)) {

      Optionsdata.push({ label: "Accept", value: 'approvebyseller' })
    }
    if (!isEmpty(Detail?.Time?.ApprovedBySeller) && isEmpty(Detail?.Time?.cancelbyseller) && isEmpty(Detail?.Time?.Dispatch) && isEmpty(Detail?.Time?.preparing) && isEmpty(Detail?.Time?.returned)) {

      Optionsdata.push({ label: "Preparing", value: 'preparing' })

    }
    if (!isEmpty(Detail?.Time?.ApprovedBySeller) && isEmpty(Detail?.Time?.cancelbyseller) && isEmpty(Detail?.Time?.returned) && isEmpty(Detail?.Time?.Dispatch) && Detail?.OrderType == 'Pickup') {

      Optionsdata.push({ label: "Order Is Ready", value: 'picked' })

    }
    if (!isEmpty(Detail?.Time?.ApprovedBySeller) && isEmpty(Detail?.Time?.cancelbyseller) && isEmpty(Detail?.Time?.returned) && isEmpty(Detail?.Time?.Dispatch) && Detail?.OrderType !== 'Pickup') {

      Optionsdata.push({ label: "Order Is Ready", value: 'qrscan' })

    }
    if (isEmpty(Detail?.Time?.completed) && isEmpty(Detail?.Time?.Shipping) && isEmpty(Detail?.Time?.returned) && !isEmpty(Detail?.Time?.Dispatch) && isEmpty(Detail?.Time?.Pickup) && Detail?.OrderType !== 'Pickup') {

      Optionsdata.push({ label: "Pickup", value: 'picked' })

    }
    if (isEmpty(Detail?.Time?.Dispatch) && isEmpty(Detail?.Time?.cancelbyseller) && isEmpty(Detail?.Time?.returned)) {
      Optionsdata.push({ label: "Cancel Order", value: 'cancelbyseller' })

    }
    Setoptions(Optionsdata)
  }, [Detail])

  //   useEffect(()=>{

  // if(Detail?.Status=='preparing'){
  //   Setselectstatus({ label: "Preparing", value: 'preparing' })
  // }
  // else if(Detail?.Status=='approvebyseller'){
  //   Setselectstatus({ label: "Accept", value: 'approvebyseller' })
  // }
  // else if(Detail?.Status=='picked'){
  //   Setselectstatus({ label: "Order Is Ready", value: 'picked' })
  // }
  // else if(Detail?.Status=='preparing'){
  //   Setselectstatus({ label: "Order Is Ready", value: 'dispatch' })
  // }
  // else if(Detail?.Status=='cancelbyseller'){
  //   Setselectstatus({ label: "Cancel Order", value: 'cancelbyseller' })
  // }
  // else if(Detail?.Status=='dispatch'){
  //   Setselectstatus({ label: "Dispatch", value: 'dispatch' })
  // }
  //   },[Detail])
  const GetOrderDetail = async () => {
    let Resp = await axiosfile.OrderDetail({ id: Id });
    if (Resp?.data?.Order?.CartId?.length > 0) {
      Resp.data.Order.CartId.map((val) => {
        if (val?.AdditionalInfo?.length > 0) {
          val.AdditionalInfo.map((modifier) => {
            if (val?.modifier?.[modifier?.question]) {
              val.modifier[modifier?.question] = val.modifier[modifier?.question]?.replace(".", ", ") + modifier?.value + "."
            }
            else {
              val.modifier = { [modifier?.question]: modifier?.value + "." }
            }
          })
        }
      })
    }
    SetDetail(Resp?.data?.Order);
  };

  const OrderAction = async (action) => {
    SetDisabled(true)
    if (!Disabled) {
      let toastid = toast.loading("Updating")
      let senddata = {
        OrderId: Detail._id,
        Status: action,
      };
      let Resp = await axiosfile.OrderStatusUpdate(senddata);
      if (Resp?.success == "success") {
        toast.update(toastid, { render: "Status Updated Successfully", type: "success", isLoading: false, autoClose: 1000 })
      } else {
        toast.update(toastid, { render: Resp?.msg, type: "error", isLoading: false, autoClose: 1000 })
      }
      GetOrderDetail();
      handlealertClose()
      handlecomfirmClose()
      handleClose()

    }
    else {
      return true
    }
    SetDisabled(false)
  };
  const handleClose = () => {
    SetShowModal(false);
  }

  const handlecomfirmClose = () => {
    setconfirmmodel(false);
  }
  const handlealertClose = () => {
    setalertmodel(false);
  }

  const Submit = (data, from) => {
    setsubmit(true)
    if (from == 'scanner') {
      if (PackNumber?.length > 0) {
        OrderAction(data)

      } else {
        toast.error("Enter the package numbers")

        // HandleShowModal()

      }
      setsubmit(false)

    }
    else {
      OrderAction(data)
      setsubmit(false)

    }


  }


  const handleChange = (e) => {
    // console.log(
    //   "handleChangehandleChange",e.target.value
    // );
    if (e?.length > 20) {
      return toast.error("Only 20 charcters are allowed...!")
    }
    if (!isEmpty(e) && !PackNumber.includes(e)) {
      if (Array.isArray(e)) {
        setPackNumber([...PackNumber, ...e])
      }
      else {
        setPackNumber([...PackNumber, ...Array(e)])

      }
    }
    setnumber('')

  };
  const Cancelpackage = (index) => {
    setPackNumber([
      ...PackNumber.slice(0, index),
      ...PackNumber.slice(index + 1, PackNumber?.length),


    ])

  }
  const Switchcamera = () => {
    setposition(!position);
    SetShowModal(false)
    setTimeout(() => {
      SetShowModal(true)

    }, 200);
  }
  const handleError = (data) => {
    console.log(
      "handleErrorhandleError", data
    );
  }
  const handleScan = (e) => {
    if (!isEmpty(e) && !PackNumber.includes(e)) {
      if (Array.isArray(e)) {
        setPackNumber([...PackNumber, ...e])
      }
      else {
        setPackNumber([...PackNumber, ...Array(e)])

      }
    }

  };
  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#6C6A81",
      background: isFocused
        ? "#F5F6F7"
        : isSelected
          ? "#F5F6F7"
          : isHovered
            ? "red"
            : "#F5F6F7",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered
          ? "#a71d24"
          : isSelected
            ? "#a71d24"
            : isFocused
              ? "#a71d24"
              : "",
        cursor: "pointer",
        color: isHovered
          ? "#fff"
          : isSelected
            ? "#fff"
            : isFocused
              ? "#fff"
              : "",
        fontSize: "13px",
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0 20px",
      backgroundColor: "#fff ",
      border: "1px solid lightgray",
      borderRadius: 10,
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#6C6A81",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#6C6A81",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };
  const orderStatuschange = (data) => {
    Setselectstatus(data)
    if (data?.value == "qrscan") {
      setconfirmmodel(true)
    }
    else {
      OrderAction(data?.value)
    }

  }

  return (
    <>

      <section id="content-wrapper">
        <Row>
          <Col
            xxl={9}
            xl={9}
            lg={8}
            md={12}
            sm={12}
            xs={12}
          >

            <div className="rv_rowborder">
              <div className="logo_invoice logo_inv_co">
                <img className='mainlogo_al wd_ht_unst' src={require('../assets/images/delpick.png')} alt="dummyimg" />
                <p className="invoice_txt">
                  OrderId : <b>#{Detail?.OrderNumber}</b>
                </p>
              </div>
              {console.log('DetailDetailDetail', Detail)}
              <div className="ov_adrsdate_dtls">
                <p className="ov_address">
                  {
                    !isEmpty(Detail?.ShopId?.Address?.FullAddress)
                      ?
                      <>
                        {Detail?.ShopId?.Address?.FullAddress}
                      </>
                      :
                      <>
                        {Detail?.ShopId?.Address?.StreetNumber
                          ? Detail?.ShopId?.Address?.StreetNumber + ","
                          : ""}
                        {Detail?.ShopId?.Address?.StreetName
                          ? Detail?.ShopId?.Address?.StreetName + ","
                          : ""}
                        {Detail?.ShopId?.Address?.City
                          ? Detail?.ShopId?.Address?.City + ","
                          : ""}
                        {Detail?.ShopId?.Address?.Country
                          ? Detail?.ShopId?.Address?.Country + "-"
                          : ""}
                        {Detail?.ShopId?.Address?.Zipcode
                          ? Detail?.ShopId?.Address?.Zipcode
                          : ""}
                      </>
                  }
                  <br />
                  {Detail?.ShopId?.Mobile}
                  <br />
                  {Detail?.ShopId?.EmailId}
                </p>
                <div className="ov_adrsdate_right">
                  <div>
                    <p className="ov_address">Date Issued : </p>
                    <p className="ov_address mt-2">Time : </p>
                  </div>
                  <div>
                    <p className="value_datetime">
                      {moment(Detail?.createdAt).format(
                        "DD/MM/YYYY"
                      )}
                    </p>
                    <p className="value_datetime mt-2">
                      {moment(Detail?.createdAt).format("HH:MM A")}
                    </p>
                  </div>
                </div>
              </div>

              <div className="ov_invoicepayment_dtls">
                <div className="ov_invoicepayment">
                  <p>Invoice to</p>
                  <p className="ov_invoicename mt-2">
                    {Detail?.DeliveryAddress?.FullName}
                    <br />
                    {Detail?.DeliveryAddress?.Mobile}
                  </p>

                  <p className="mt-2">
                    {
                      !isEmpty(Detail?.Address?.FullAddress) ?
                        <>{Detail?.Address?.FullAddress}</>


                        : (isEmpty(Detail?.Address) ? (
                          <>
                            {Detail?.DeliveryAddress?.Doornumber
                              ? Detail?.DeliveryAddress?.Doornumber +
                              ","
                              : ""}
                            {Detail?.DeliveryAddress?.Street
                              ? Detail?.DeliveryAddress?.Street + ","
                              : ""}
                            {Detail?.DeliveryAddress?.Street2
                              ? Detail?.DeliveryAddress?.Street2 + ","
                              : ""}
                            <br />
                            {Detail?.DeliveryAddress?.City
                              ? Detail?.DeliveryAddress?.City + ","
                              : ""}
                            {Detail?.DeliveryAddress?.Area
                              ? Detail?.DeliveryAddress?.Area + ","
                              : ""}
                            -
                            {Detail?.DeliveryAddress?.Zipcode
                              ? Detail?.DeliveryAddress?.Zipcode + ","
                              : ""}
                            <br />
                            {Detail?.DeliveryAddress?.Mobile}
                            <br />
                            {Detail?.DeliveryAddress?.EmailId}
                          </>
                        ) : (
                          <>
                            {Detail?.Address?.Doornumber
                              ? Detail?.Address?.Doornumber + ","
                              : ""}
                            {Detail?.Address?.Street
                              ? Detail?.Address?.Street + ","
                              : ""}
                            {Detail?.Address?.Street2
                              ? Detail?.Address?.Street2 + ","
                              : ""}
                            <br />
                            {Detail?.Address?.City
                              ? Detail?.Address?.City + ","
                              : ""}
                            {Detail?.Address?.Area
                              ? Detail?.Address?.Area + ","
                              : ""}
                            -
                            {Detail?.Address?.Zipcode
                              ? Detail?.Address?.Zipcode + ","
                              : ""}
                            <br />
                            {Detail?.Address?.Mobile}
                            <br />
                            {Detail?.Address?.EmailId}
                          </>
                        ))
                    }
                  </p>
                </div>
                <div className="mb-4">
                  <p className="ov_paymentdtl_title">
                    Payment Details
                  </p>
                  <div className="ov_paymentdtls">
                    <div>
                      <p className="ov_address ov_address_wrap">
                        Total Amount
                      </p>
                      <p className="ov_address ov_address_wrap mt-2">
                        Payment Status
                      </p>
                      <p className="ov_address ov_address_wrap mt-2">
                        Transaction ID
                      </p>
                      <p className="ov_address ov_address_wrap mt-2">
                        Delivery Time {Detail?.DeliveryStartTime ? "between" : "before"}
                      </p>
                    </div>
                    <div className="ps-2">
                      <p className="value_datetime">
                        : {Detail?.ShopId?.CurrencySymbol}
                        {Detail?.Price?.PayAmount}
                      </p>
                      <p className="value_datetime greentxt mt-2">
                        : {isEmpty(Detail?.Time?.Paid)
                          ? "Pending"
                          : "Paid"}
                      </p>
                      {isEmpty(Detail?.Time?.Paid) ? (
                        <p className="value_datetime mt-2">
                          : Pending
                        </p>
                      ) : (
                        <p className="value_datetime mt-2">
                          : #{Detail?.TransactionHistory?.object?.id}
                        </p>
                      )}
                      <p className="value_datetime mt-2 val_date_time_nowrap">
                        : {Detail?.DeliveryStartTime ? (DateTimeForm(new Date(Detail?.DeliveryStartTime), undefined, undefined, true) + "-") : ""}
                        {DateTimeForm(new Date(Detail?.DeliveryTime), undefined, undefined, true)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className='order_tables_cmn'>
                  <StyledDataGrid
                    
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    rows={rows}
                    columns={columns}
                    components={{
                      Pagination: CustomPagination,
                    }}
                    className='campaign_muitbl'
                   

                  />


                </div> */}

                            <TableContainer component={Paper}>
                              <Table
                                sx={{ minWidth: 650 }}
                                className="order_table"
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow className="ov_tablehead">
                                    <TableCell>No</TableCell>
                                    <TableCell align="left">Product</TableCell>
                                    {/* <TableCell align="left">Rate</TableCell> */}
                                    <TableCell align="center">Notes</TableCell>
                                    <TableCell align="center">Modifiers</TableCell>
                                    <TableCell align="left">Quantity</TableCell>
                                    <TableCell align="left">Totals</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {Detail?.CartId?.length > 0 &&
                                    Detail?.CartId?.map((latestorders, ind) => (
                                      <TableRow
                                        className="ov_tabledtls"
                                        key={latestorders._id}
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                        }}
                                      >
                                        <TableCell component="th" scope="row">
                                          {ind + 1}
                                        </TableCell>
                                        <TableCell align="left">
                                          {latestorders?.ProductId?.ProductName}
                                        </TableCell>
                                        {/* <TableCell align="left">
                                        {Detail?.ShopId?.CurrencySymbol}{" "}
                                        {latestorders?.TotalPrice}
                                      </TableCell> */}
                                        <TableCell align="left">
                                          {
                                            (Array.isArray(latestorders?.Notes) && latestorders?.Notes?.length > 0)
                                              ?
                                              <>
                                                {
                                                  returnArrayString(latestorders?.Notes, undefined, undefined, undefined, 'notes')
                                                }
                                              </>
                                              :
                                              <p className="text-center">No Notes</p>
                                          }
                                          {console.log('latestorderslatestorders', latestorders, Detail)}
                                        </TableCell>
                                        <TableCell align="left">
                                          {
                                            (latestorders?.modifier && Object.keys(latestorders?.modifier)?.length > 0) ?
                                              Object.keys(latestorders?.modifier)?.map((val) => {
                                                return (
                                                  <p className="d-flex align-items-center justify-content-between conten_modi">
                                                    <span>
                                                      {val}
                                                    </span>
                                                    <span>:</span>
                                                    <span>{latestorders?.modifier?.[val]}</span></p>
                                                )
                                              })
                                              :
                                              <p className="text-center">No Modifers</p>

                                          }
                                        </TableCell>
                                        <TableCell align="left">
                                          {latestorders.Quantity}
                                        </TableCell>
                                        <TableCell align="left">
                                          {
                                            NumberChange(
                                              latestorders?.TotalPrice
                                            ).toFixed(2)
                                          }
                                        </TableCell>
                                        {/* <TableCell className='price_clr' align="center">{latestorders.price} <i class="fa fa-angle-right" aria-hidden="true"></i></TableCell> */}
                                      </TableRow>
                                    ))}
                                </TableBody>
                              </Table>
                            </TableContainer>

                            <div className="ov_totalamnt_full">
                              <div className="ov_bottomsug">
                                <p className="ov_totalamnt_left mt-0"></p>
                                <p className="ov_address"></p>
                              </div>
                              <div className="ov_totalamnt_whole">
                                <div className="ov_totalamnt_top">
                                  <div>
                                    <p className="ov_address">Subtotal</p>
                                    <p className="ov_address mt-2">Taxes</p>
                                    {/* <p className="ov_address mt-2">Commission</p> */}
                                    {/* <p className='ov_address mt-2'>Discount</p> */}
                                    {Detail?.Coupon &&
                                      <p className='ov_address mt-2'>{Detail?.couponDetails?.DiscountInPercentange ? `Discount(${Detail?.couponDetails?.DiscountInPercentange + "%"})` : `Discount(${Detail?.ShopId?.CurrencySymbol}${Detail?.couponDetails?.DiscountInPrice})`}</p>

                                    }
                                    <p className="ov_address mt-2">Seller Tip</p>
                                  </div>
                                  <div>
                                    <p className="value_datetime">
                                      {Detail?.ShopId?.CurrencySymbol}{" "}
                                      {NumberChange(Detail?.Price?.CartValue).toFixed(2)}
                                    </p>
                                    <p className="value_datetime mt-2">
                                      {Detail?.ShopId?.CurrencySymbol}{" "}
                                      {NumberChange(Detail?.Price?.Taxes).toFixed(2)}
                                    </p>
                                    {/* <p className="value_datetime mt-2">
                                    {Detail?.ShopId?.CurrencySymbol}
                                    {Detail?.Price?.DeliveryTimeCharges}
                                  </p> */}
                      {Detail.Coupon &&
                        <>
                          {Detail?.couponDetails?.discountPrice == "" ?
                            <></>
                            :
                            <p className="value_datetime mt-2">
                              {Detail?.ShopId?.CurrencySymbol}
                              {NumberChange(Detail?.couponDetails?.discountPrice).toFixed(
                                2
                              )}
                            </p>}
                        </>
                      }
                      {/* <p className='value_datetime mt-2'>{Detail?.ShopId?.CurrencySymbol} {Detail?.Price?.Coupon}</p> */}
                      <p className="value_datetime mt-2">
                        {Detail?.ShopId?.CurrencySymbol}{" "}
                        {NumberChange(Detail?.Price?.SellerTipsInValue).toFixed(2)}
                      </p>
                    </div>
                  </div>
                  <div className="ov_totalamnt_bottom">
                    <p className="ov_totalamnt_left">
                      Total Amount
                    </p>
                    <p className="ov_totalamnt_right">
                      {Detail?.ShopId?.CurrencySymbol}{" "}
                      {
                        (NumberChange(Detail?.Price?.CartValue) + NumberChange(Detail?.Price?.Taxes) - NumberChange(Detail?.Price?.discountPrice) + NumberChange(Detail?.Price?.SellerTipsInValue)).toFixed(2)
                      }
                      {/* {(Number(Detail?.Price?.PayAmount).toFixed(2))} */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {Detail?.Driver?._id && (
              <div className="rv_rowborder mt-3">
                <div>
                  <p className="ov_paymentdtl_title mar_tp_lg">
                    Choosen Driver For Pickup
                  </p>

                  <div className="ov_paymentdtls payment_width">
                    <div>
                      <p className="ov_address wht_spc_nowrap">
                        Driver Name
                      </p>
                      <p className="ov_address mt-2 wht_spc_nowrap">
                        Email-Id
                      </p>
                      <p className="ov_address mt-2 wht_spc_nowrap">
                        Mobile
                      </p>
                    </div>
                    <div>
                      <p className="value_datetime no_wrap_tx_rig">
                        : {Detail?.Driver?.FirstName}{" "}
                        {Detail?.Driver?.LastName}
                      </p>
                      <p className="value_datetime greentxt mt-2 no_wrap_tx_rig">
                        : {Detail?.Driver?.EmailId}
                      </p>
                      <p className="value_datetime mt-2 no_wrap_tx_rig">
                        : {Detail?.Driver?.Mobile}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Col>
          <Col
            xxl={3}
            xl={3}
            lg={4}
            md={12}
            sm={12}
            xs={12}
            className="ov_reducepad"
          >

            {/* <div className="ov_pendingbtn">
              <button
                className="orange_btn"
                onClick={() => { <i class="fa-solid fa-ellipsis" />}}
              >
               Status
              </button>
            </div> */}

            {/* <Select
                            options={Options}
                            defaultValue={status}
                            value={status}
                            onChange={(data) => orderStatuschange(data)}
                            placeholder='Status'
                            styles={stylesgraybg}
                            isSearchable={false}
                          /> */}
            <div className="mt-4">
              <OrderStatus
                Orderdata={Detail}
                OrderAction={OrderAction}
                setconfirmmodel={setconfirmmodel}
                setOrderData={setOrderData}
              />
            </div>



          </Col>

        </Row>


      </section>

      {showModal &&
        <Modal
          show={showModal}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          centered
          className="reg_gender_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "18px" }}>
              Scan the Qr code to add the package number
            </Modal.Title>
            {/* <Modal.Title></Modal.Title> */}

          </Modal.Header>
          <Modal.Body>


            <QrReader
              delay={1000}
              onError={handleError}
              onScan={(e) => handleScan(e)}
              style={{ width: '100%', height: "100%" }}
              constraints={{ facingMode: position ? 'environment' : "user" }}

            />


            <div className="rv_rowborder mt-3">
              {/* {PackNumber?.map((item) =>
            <text>{item}</text>
          )
          } */}
              <div className="d-flex align-items-center gap-2 flex-wrap scantagsec ">
                {PackNumber?.map((item, index) =>
                  <p className="mb-0 labeltags">{item} <IoMdCloseCircle className="closeicons" onClick={() => Cancelpackage(index)} /></p>
                )
                }

              </div>
              <div className="text-center">
                <p>
                  Enter Manually
                </p>
                <div className="d-flex align-items-center gap-3 justify-content-center mb-3">

                  <input type="text" value={number} onChange={(e) => setnumber((e.target.value).trim())} maxLength={50} />
                  {
                    <button
                      className="blue_btn add_deliveryprsn mt-0 dp_btn_hover ml-2"
                      type="button"
                      onClick={() => handleChange(number)}
                    >
                      Add
                    </button>
                  }
                </div>

              </div>

              <div className="text-center">
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => !submit && Submit('dispatch', 'scanner')}
                  >
                    Confirm
                  </button>
                }
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0  dp_btn_hover"
                    type="button"
                    onClick={() => { Switchcamera() }}
                  >
                    Switch camera
                  </button>
                }
              </div>
            </div>
          </Modal.Body>
        </Modal>
      }


      {confirmmodel &&
        <Modal
          show={confirmmodel}
          onHide={handlecomfirmClose}
          backdrop="static"
          keyboard={false}
          centered
          className="reg_gender_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "18px" }}>
              Order for Delivery
            </Modal.Title>

          </Modal.Header>
          <Modal.Body>

            <div className="rv_rowborder mt-3">



              <div className="text-center">
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => { SetShowModal(true); handlecomfirmClose() }}
                  >
                    Scan the Qr
                  </button>
                }
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => { setalertmodel(true); handlecomfirmClose() }}
                  >
                    Dispatch
                  </button>
                }

              </div>
            </div>
          </Modal.Body>
        </Modal>
      }
      {alertmodel &&
        <Modal
          show={alertmodel}
          onHide={handlealertClose}
          backdrop="static"
          keyboard={false}
          centered
          className="reg_gender_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "18px" }}> Your item will be packed by the delivery person,Are you sure want to confirm?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>


            <div className="rv_rowborder mt-3">



              <div className="text-center">
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => !submit && Submit('dispatch', 'manual')}
                  >
                    Confirm
                  </button>
                }
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0  dp_btn_hover"
                    type="button"
                    onClick={() => { handlealertClose() }}
                  >
                    Cancel
                  </button>
                }
              </div>
            </div>
          </Modal.Body>
        </Modal>
      }

    </>
  );
}

export default OrdersView;
